// Shared values — mirrors backend config/constants.py.

// Deal payment page (/pay/deal/:token) — DealPageState
export const DEAL_PAGE_STATE = {
  OPEN: 'open',
  PAID: 'paid',
  EXPIRED: 'expired',
  CANCELLED: 'cancelled',
  REFUNDED: 'refunded',
};

// Query parameter Stripe Checkout adds when it returns to the page — DEAL_PAID_RETURN_PARAM
export const DEAL_PAID_RETURN_PARAM = 'paid';

// How a business confirms it's them — DealVerifyChannel
export const DEAL_VERIFY_CHANNEL = {
  PHONE: 'phone',
  EMAIL: 'email',
};
